import * as React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Container,
  ListItemIcon,
  IconButton,
  Grid,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import menu from "../../assets/menu.png";
// import logo from "../../assets/images/logo.png";
import logo from "../../assets/images/logo-tm.png";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { menuItems } from "../../constants/const";
import { Close } from "@mui/icons-material";
import { CustomButton } from "../../utils/CustomTagComponents";
import CountryDropdown from "../CountryDropdown";
import LoginQRModal from "../LoginQRModal ";
import LoginIcon from "@mui/icons-material/Login";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../../store/actions/AuthActions";
import { Popper, Paper, ClickAwayListener } from "@mui/material";
import { useEffect } from "react";

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [qrModelOpen, setQrModelOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (drawerOpen) {
      const scrollY = window.scrollY;

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
    } else {
      const scrollY = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";

      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }, [drawerOpen]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const { country_name, auth } = useSelector((state) => state.auth || {});
  const isLoggedIn = Boolean(auth?.idToken || auth?.localId || auth?.email);

  const sidebarMenuItems = menuItems(country_name || "Germany");

  const isActive = (val) => {
    if (val.activePaths) {
      return val.activePaths.some((p) =>
        location.pathname.startsWith(p)
      );
    }
    return location.pathname === val.path;
  };

  // const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  // const handleMenuClose = () => setAnchorEl(null);

  // 🔹 Logout handler
  const handleLogout = () => {
    dispatch(Logout(navigate));
    handleClose();
  };

  return (
    <Container sx={{
      px: { xs: 3, sm: 4, md: 6 },
      paddingLeft: { xs: "24px !important", md: "48px !important" },
      paddingRight: { xs: "24px !important", md: "48px !important" }
    }}>
      <Box sx={{ flexGrow: 1, my: 1 }}>
        <AppBar
          position="static"
          sx={{ backgroundColor: "transparent", boxShadow: "none" }}
        >
          <Toolbar
            sx={{
              padding: "0px !important",
              position: "relative",
              minHeight: "64px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                onClick={toggleDrawer(true)}
                disableRipple
                sx={{
                  p: 0,
                  backgroundColor: "transparent",

                  "&:hover": {
                    backgroundColor: "transparent",
                  },

                  "&:focus": {
                    backgroundColor: "transparent",
                  },

                  "&:active": {
                    backgroundColor: "transparent",
                  },
                }}>
                <MenuIcon sx={{ fontSize: 40, cursor: "pointer", color: "#fd0000" }} />
              </IconButton>
            </Box>
            <Box
              sx={{
                position: "absolute",
                left: { xs: "45%", sm: "30%", md: "50%" }, // shift logo slightly left on mobile
                transform: {
                  xs: "translateX(-45%)",
                  sm: "translateX(-30%)",
                  md: "translateX(-50%)",
                }, // adjust translation
                display: "flex",
                alignItems: "center",
              }}
            >
              <a href="/">
                <Box
                  component="img"
                  src={logo}
                  alt="Logo"
                  sx={{
                    width: { xs: "100px", sm: "137px" },
                    height: "51px",
                    objectFit: "contain",
                  }}
                />
              </a>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                ml: "auto",
              }}
            >
              <CountryDropdown />

              {!isLoggedIn ? (
                <>
                  <CustomButton
                    variant="contained"
                    size="small"
                    sx={{
                      p: "9px",
                      paddingX: 1.2,
                      height: "45px",
                      // minWidth: 100,
                      // ml: 2,
                      display: { xs: "none", sm: "inline-flex" },
                    }}
                    onClick={() => setQrModelOpen(true)}
                  >
                    Log-In
                  </CustomButton>

                  <Box
                    component="span"
                    sx={{
                      display: { xs: "inline-flex", sm: "none" },
                      cursor: "pointer",
                      backgroundColor: "#fd0000",
                      borderRadius: 1,
                      p: 1,
                    }}
                    onClick={() => setQrModelOpen(true)}
                  >
                    <LoginIcon sx={{ color: "#fff", fontSize: 20 }} />
                  </Box>
                </>
              ) : (
                <>
                  {/* 🔹 Show avatar and name when logged in */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      ml: { xs: 0.5, md: 1 },
                      cursor: "pointer",
                    }}
                    onClick={handleMenuOpen}
                  >
                    <Avatar
                      alt={auth?.name || "User"}
                      src={auth?.profile_picture || ""}
                      sx={{ width: 36, height: 36 }}
                    />
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 600, color: "#333",
                        display: { xs: "none", sm: "block" },
                      }}
                    >
                      {auth?.name || "Guest"}
                    </Typography>
                  </Box>

                  <Popper
                    open={open}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    modifiers={[
                      {
                        name: "offset",
                        options: {
                          offset: [0, 0],
                        },
                      },
                    ]}
                    style={{ zIndex: 1300 }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <Paper
                        elevation={3}
                        sx={{
                          mt: 1,
                          borderRadius: "10px",
                          minWidth: 100,
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >

                        {/* Menu Items */}
                        <Box
                          sx={{
                            px: 2,
                            py: 1.5,
                            cursor: "pointer",
                            fontSize: "14px",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                          onClick={handleLogout}
                        >
                          Logout
                        </Box>
                      </Paper>
                    </ClickAwayListener>
                  </Popper>
                </>
              )}
            </Box>
          </Toolbar>
        </AppBar>
      </Box>

      {/* Menu drawer */}

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)} >
        <Box
          sx={{
            width: { xs: "90vw", sm: 400 },
            backgroundColor: "#002045",
            height: "100vh",
            overflowY: "auto",
            p: { xs: "10px", sm: "15px" },
            scrollbarWidth: "thin",
            scrollbarColor: "#ffffff transparent",

            /* Chrome, Edge, Safari */
            "&::-webkit-scrollbar": {
              width: "6px",
            },

            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },

            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ffffff",
              borderRadius: "10px",
            },

            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#c40000",
            },
          }}
          role="presentation"
          onClick={toggleDrawer(false)}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={toggleDrawer(false)}>
              <Close sx={{ fontSize: "34px", color: "#ffffff" }} />
            </IconButton>
          </Box>

          {sidebarMenuItems?.map((val) => (
            <Link
              to={val.path}
              key={val.label}
              onClick={() => {
                // Remove course filters
                localStorage.removeItem("courseFilters");
                localStorage.removeItem("courseFilterLabels");
                localStorage.removeItem("courseSearch");
                localStorage.removeItem("courseShowSaved");
                localStorage.removeItem("coursePage");

                localStorage.removeItem("jobFilters");
                localStorage.removeItem("jobFilterLabels");
                localStorage.removeItem("jobseSearch");
                localStorage.removeItem("jobPage");

                // Close drawer
                toggleDrawer(false)();
              }}
              style={{ textDecoration: "none" }}
            >
              <Grid
                container
                spacing={2}
                alignItems="center"
                sx={{ cursor: "pointer", background: isActive(val) ? "#fd0000" : "#002045", borderRadius: "20px" }}
              >
                <Grid size={{ xs: 10, sm: 10 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", sm: "14px", md: "16px" },
                      fontWeight: 700,
                      // letterSpacing: "0.89px",
                      p: 2,
                      color: "#ffffff", //
                    }}
                  >
                    {val.label}
                  </Typography>
                </Grid>
                <Grid
                  size={{ xs: 2, sm: 2 }}
                  sx={{ textAlign: "right", pr: 1 }}
                >
                  <ChevronRightIcon sx={{ fontSize: "35px", color: "#ffffff" }} />
                </Grid>
              </Grid>
            </Link>
          ))}
        </Box>
      </Drawer>

      {qrModelOpen && (
        <LoginQRModal
          open={qrModelOpen}
          handleClose={() => setQrModelOpen(false)}
        />
      )}
    </Container>
  );
}
